import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './tokens.css';
import './styles.css';
import { App } from './App.tsx';
import { quietly } from './lib/quietly.ts';

// Last resort (M55): a failure nothing handled is counted like a failed background load, so the
// shell says something didn't work instead of nothing happening. Still logged by the browser.
window.addEventListener('unhandledrejection', event => { quietly(event.reason); });

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
